import { useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import moduleCsvFile from "../../Static/moduleList.csv";
import CSVUploadDropZone from "../CSVUpload/CSVUploadDropZone";
import { CloseIcon } from "../../Static/icons/iconshere";
import apiClient from "../../apiClient";
import { CREATE_BULK_MODULE_BY_CSV } from "../../apiClient/apiEndpoints";
import { useSelector } from "react-redux";

const headers = ["Name"];
const validateCsvSingleObject = (csvData) => {
  for (const header of headers) {
    if (!(header in csvData) || !csvData[header]?.trim()) {
      return false;
    }
  }
  return true;
};

const isValidCsv = (csvJson) => {
  const validList = [];
  for (const csvData of csvJson) {
    if (!validateCsvSingleObject(csvData)) {
      return false;
    } else {
      validList.push({
        name: csvData?.Name,
      });
    }
  }
  return validList;
};

const CsvModuleUpload = ({ showCsvModule, handleCloseCsvModule }) => {
  const configData = useSelector((state) => state.configSlice);
  const [csvModuleList, setCsvModuleList] = useState([]);
  const [loading, setLoading] = useState(false);
  const UNO_URL = configData?.config?.UNO_URL;

  const handleModuleCsvUpload = (jsonData) => {
    const validCsvData = isValidCsv(jsonData);
    if (!validCsvData) {
      return;
    }
    setCsvModuleList(validCsvData);
  };

  const closeModal = () => {
    setCsvModuleList([]);
    handleCloseCsvModule(false);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const payload = {
        moduleJson: csvModuleList,
      };
      const res = await apiClient.post(`${UNO_URL}${CREATE_BULK_MODULE_BY_CSV}`, payload);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      closeModal();
    }
  };

  return (
    <>
      <Modal show={showCsvModule} onHide={closeModal} className="NewModule" centered size="md">
        <Modal.Header className="modalheader">
          Upload CSV
          <span onClick={closeModal}>
            <CloseIcon />
          </span>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <div className="row">
              {csvModuleList.length > 0 ? (
                <div className="csvfiledatalist">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {csvModuleList.map((module, index) => (
                        <tr key={module.name}>
                          <td>{index + 1}</td>
                          <td>{module.name}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="csvuploadefs">
                  <CSVUploadDropZone
                    onFileUpload={handleModuleCsvUpload}
                    text="Drag & drop or choose file to upload CSV"
                  />
                  <h6 className="mt-3 mb-0">Required Fields*</h6>
                  <p className="text-xs">
                    Name <br />
                  </p>
                  <div className="d-flex justify-content-between align-item-center mt-3">
                    <p className="mb-0">
                      <a className="download-text" style={{ cursor: "pointer" }} href={moduleCsvFile}>
                        <span>Download Template</span>
                      </a>
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="footerbtn pt-0">
          <Button onClick={closeModal}> Cancel </Button>
          <Button onClick={handleSave}> Save </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CsvModuleUpload;
